export default class FaviconParser
{
    static parseFavicon(){
        let favicon = document.querySelector('link[rel="shortcut icon"]')
        favicon.href = process.env.VUE_APP_FAVICON_PATH || "/favicons/assetpool-favicon.png"
    }
}